import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import { CONTENT_DISTRIBUTION_DELIVERY } from '../constant/constant';
import { DropDownList } from '@progress/kendo-react-dropdowns';

const ContentDistributionDeliveryForm = ({ item, setItem }) => {
    const lang = useTranslation();

    const getCredentialData = () => {
        const deliveryType = item?.Delivery?._id ?? item?.Delivery;
        switch (deliveryType) {
            case CONTENT_DISTRIBUTION_DELIVERY.S3:
                return {
                    accessKeyId: item?.accessKeyId ?? "",
                    secretAccessKey: item?.secretAccessKey ?? "",
                    region: item?.region ?? "",
                    bucketName: item?.bucketName ?? "",
                    CdnUrl: item?.CdnUrl ?? ""
                };
            case CONTENT_DISTRIBUTION_DELIVERY.FTP:
                return {
                    host: item?.host ?? "",
                    username: item?.username ?? "",
                    password: item?.password ?? "",
                    remotePath: item?.remotePath ?? ""
                };
            default:
                return {};
        }
    };

    const [deliveries, setDeliveries] = useState([]);

    useEffect(() => {
        const deliverRes = Object.keys(CONTENT_DISTRIBUTION_DELIVERY).map((x) => ({
            _id: CONTENT_DISTRIBUTION_DELIVERY[x],
            Description: x
        }));
        setDeliveries(deliverRes);
    }, []);

    const onChange = (e) => {
        const { name, value } = e.target;
        setItem(prev => ({ ...prev, [name]: value}));
    };

    const onDeliveryChange = (e) => {
        const selected = e.value;
        const newData = { Delivery: selected, ...getCredentialData() };
        setItem(newData);
    };

    return (
        <>
            <div className="row">
                <div className="col-6">
                    <label>{lang.delivery_label}</label>
                    <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={deliveries}
                        name="Delivery"
                        textField="Description"
                        dataItemKey="_id"
                        className="form-control form-control-sm"
                        value={item.Delivery}
                        onChange={onDeliveryChange}
                    />
                </div>
            </div>
            <div className="border form-group p-2 mt-3" style={{ border: "1px solid #ced4da", boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)", backgroundColor: "white" }}>
                {item?.Delivery?._id === CONTENT_DISTRIBUTION_DELIVERY.S3 && (
                    <div className="row mt-3">
                        <div className="col-4">
                            <label>{lang.access_key_id_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="accessKeyId" value={item.accessKeyId} onChange={onChange} />
                        </div>
                        <div className="col-4">
                            <label>{lang.secret_access_key_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="secretAccessKey" value={item.secretAccessKey} onChange={onChange} />
                        </div>
                        <div className="col-4">
                            <label>{lang.region_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="region" value={item.region} onChange={onChange} />
                        </div>
                        <div className="col-4 mt-2">
                            <label>{lang.bucket_name_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="bucketName" value={item.bucketName} onChange={onChange} />
                        </div>
                        <div className="col mt-2">
                            <label>{lang.cdn_url_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="CdnUrl" value={item.CdnUrl} onChange={onChange} />
                        </div>
                    </div>
                )}
                {item?.Delivery?._id === CONTENT_DISTRIBUTION_DELIVERY.FTP && (
                    <div className="row mt-3">
                        <div className="col-4">
                            <label>{lang.ftp_host_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="host" value={item.host} onChange={onChange} />
                        </div>
                        <div className="col-4">
                            <label>{lang.username_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="username" value={item.username} onChange={onChange} />
                        </div>
                        <div className="col-4">
                            <label>{lang.password_label} *</label>
                            <input type="password" className="form-control form-control-sm" name="password" value={item.password} onChange={onChange} />
                        </div>
                        <div className="col-6 mt-2">
                            <label>{lang.ftp_remote_path_label} *</label>
                            <input type="text" className="form-control form-control-sm" name="remotePath" value={item.remotePath} onChange={onChange} />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};


export default ContentDistributionDeliveryForm